import Layout from '../components/Layout';
import Hero from '../components/Hero';
import Features from '../components/Features';
import CallToAction from '../components/CallToAction';
import BlogPreview from '../components/BlogPreview';
import ServiceDiscontinuation from '../components/ServiceDiscontinuation';
import DeveloperSupport from '../components/DeveloperSupport';
import CampaignSupport from '../components/CampaignSupport';

const Index = () => {
  return (
    <Layout>
      <Hero />
      <ServiceDiscontinuation />
      <Features />
      <DeveloperSupport />
      <CampaignSupport />
      <CallToAction />
    </Layout>
  );
};

export default Index;
